import React from 'react'

const ConditonalLink = ({isLink, children}) => (
  isLink ? 
    <a className="authorised-person__assign">
      {children}
    </a> : children
)

export default ConditonalLink


// WEBPACK FOOTER //
// ./src/auth-personnel/views/conditional-link.jsx